import React, { useEffect, useState } from "react";
import { Button, Container, Dropdown, Offcanvas } from "react-bootstrap";
import { Images } from "../Components/Images";
import { NavLink } from "react-router-dom";
import ConnectWallet from "../Modals/ConnectWallet";
import { UseProvider } from "../Hooks/useWeb3";
import { getAllPages } from "../actions/settings";
import { useSelector } from "react-redux";
import { CHAINS } from "../Config/env";
import { useNavigate } from "react-router-dom";
import { getSiteSettings } from "../actions/settings";
import { API_URL } from "../Config";

const Header = () => {
  const { walletaddress } = useSelector((state) => state.wallet);
  const { networkSwitch } = useSelector((state) => state.networkSwitching);
  const [pages, setPages] = useState();
  const navigate = useNavigate();
  const getPages = async () => {
    try {
      let { status, message, result } = await getAllPages();
      if (status == "success") {
        setPages(result);
      }
    } catch (err) { }
  };

  // connect wallet state
  const [showWallet, setShowWallet] = useState(false);

  const handleCloseWallet = () => setShowWallet(false);
  const handleShowWallet = () => setShowWallet(true);

  // other states
  const [isScollred, setIsScrolled] = useState(false);

  // canva state
  const [show, setShow] = useState(false);

  const [isConnected, setConnected] = useState(false);
  const [accountInfo, setAccountInfo] = useState("");

  const [settingsData, setSettingsData] = useState();


  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const logOut = async () => {
    setAccountInfo("");
    if (walletaddress && localStorage.getItem("wcv2") != null) {
      const provider = await UseProvider();
      await provider.disconnect();
    }
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const getSettingsData = async () => {
    try {
      let { status, message, result } = await getSiteSettings();
      console.log("🚀 ~ getSettingsData ~ status, message, result:", status, message, result)
      if (status === "success") {
        setSettingsData(result);
      }
    } catch (err) { }
  };

  useEffect(() => {
    getPages();
    getSettingsData();
  }, []);

  useEffect(() => {
    const walletAddress = walletaddress ? setAccountInfo(walletaddress) : "";
  }, [showWallet]);

  useEffect(() => {
    setConnected(walletaddress ? true : false);
    const walletAddress = walletaddress ? setAccountInfo(walletaddress) : "";
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [walletaddress]);

  const [drop, setDrop] = useState(false);

  const handleWallet = () => {
    !isConnected && setShowWallet(true);
  }

  return (
    <>
      <div className={isScollred ? "header__scrolled new_header" : "new_header"}>
        <Container className="header_custom_container custom_container">
          <div className="content_sec">
            {/* <div className="nav_cnts"> */}
            {/* 
              {pages && pages.length > 0 ? (
                <>
                  {pages[0].pageName == "Dapp" && pages[0].status == true ? (
                    <button
                      // to={isConnected ? "/dashboard" : "/"}
                      onClick={(e) =>
                        isConnected ? navigate("/dashboard") : toast.error("Please Connect Wallet")
                      }
                    >
                      Dapp
                    </button>
                  ) : (
                    ""
                  )}

                  {pages[1].pageName == "Transaction History" &&
                    pages[1].status == true ? (
                    <button
                      // to={isConnected ? "/transactionHistory" : "/"}
                      onClick={(e) =>
                        isConnected ? navigate("/transactionHistory") : toast.error("Please Connect Wallet")
                      }
                    >
                      Transaction History
                    </button>
                  ) : (
                    ""
                  )}

                  {pages[2].pageName == "Market Opportunities" &&
                    pages[2].status == true ? (
                    <button
                      // to={isConnected ? "/opportunities" : "/"}
                      onClick={(e) =>
                        isConnected ? navigate("/opportunities") : toast.error("Please Connect Wallet")
                      }
                    >
                      Market Opportunities
                    </button>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )} */}
            {/* <NavLink to={isConnected ? "/dashboard" : "/"}>Dashboard</NavLink>
              <NavLink to={isConnected ? "/transactionHistory" : "/"}>Transaction History</NavLink>
              <NavLink to={isConnected ? "/opportunities" : "/"}>Market Opportunities</NavLink> */}
            {/* {pages && pages.length > 0 ? (
                <>
                  {pages[0].pageName == "Dapp" && pages[0].status == true ? (
                    <NavLink to={isConnected ? "/dashboard" : "/"}>
                      Dapp
                    </NavLink>
                  ) : (
                    ""
                  )}

                  {pages[1].pageName == "Transaction History" &&
                  pages[1].status == true ? (
                    <NavLink to={isConnected ? "/transactionHistory" : "/"}>
                      Transaction History
                    </NavLink>
                  ) : (
                    ""
                  )}

                  {pages[2].pageName == "Market Opportunities" &&
                  pages[2].status == true ? (
                    <NavLink to={isConnected ? "/opportunities" : "/"}>
                      Market Opportunities
                    </NavLink>
                  ) : (
                    ""
                  )}

                  {pages[3].pageName == "Subscriptions" &&
                  pages[3].status == true ? (
                    <NavLink to={isConnected ? "/plans" : "/"}>
                      Subscriptions
                    </NavLink>
                  ) : (
                    ""
                  )}

                  {pages[5].pageName == "ScheduleHistory" &&
                  pages[5].status == true ? (
                    <NavLink to={isConnected ? "/scheduleHistory" : "/"}>
                      Schedule History
                    </NavLink>
                  ) : (
                    ""
                  )}

                  {pages[4].pageName == "Support" && pages[4].status == true ? (
                    <NavLink to={isConnected ? "/supportTicket" : "/"}>
                      Support
                    </NavLink>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )} */}
            {/* </div> */}


            <div className="cnt_btn_sec">
              <NavLink to="/" className="logobox">
                <img src={Images.logo} className="img-fluid logo" alt="" />
                {/* {console.log(API_URL + '/public/images/' + settingsData?.sitelogo, "API_URL + '/' + settingsData?.sitelogo")}
              <img src={API_URL + '/public/images/' + settingsData?.sitelogo} className="img-fluid logo" alt="" /> */}
              </NavLink>
              <div className="nav_cnts snd_navCnts">
                <NavLink to={isConnected ? "/dashboard" : "javascript:;"} onClick={handleWallet}>Dashboard</NavLink>
                <NavLink to={isConnected ? "/transactionHistory" : "javascript:;"} onClick={handleWallet}>Transaction History</NavLink>
                <NavLink to={isConnected ? "/opportunities" : "javascript:;"} onClick={handleWallet}>Market Opportunities</NavLink>

                <NavLink to={isConnected ? "/plans" : "javascript:;"} onClick={handleWallet}>Plans</NavLink>
                <NavLink to={isConnected ? "/scheduleHistory" : "javascript:;"} onClick={handleWallet}>Schedule History</NavLink>
                <NavLink to={isConnected ? "/vault" : "javascript:;"} onClick={handleWallet}>Vault</NavLink>
                <NavLink to={isConnected ? "/referral" : "javascript:;"} onClick={handleWallet}>Referral</NavLink>


                {/* {pages && pages.length > 0 ? (
                  <>

                    {pages[3].pageName == "Plans" &&
                      pages[3].status == true ? (
                      <button
                        // to={isConnected ? "/plans" : "/"}
                        onClick={(e) =>
                          isConnected ? navigate("/plans") : toast.error("Please Connect Wallet")
                        }
                      >
                        Plans
                      </button>
                    ) : (
                      ""
                    )}

                    {pages[5].pageName == "ScheduleHistory" &&
                      pages[5].status == true ? (
                      <button
                        // to={isConnected ? "/scheduleHistory" : "/"}
                        onClick={(e) =>
                          isConnected ? navigate("/scheduleHistory") : toast.error("Please Connect Wallet")
                        }
                      >
                        Schedule History
                      </button>
                    ) : (
                      ""
                    )}

                    {pages[6].pageName == "Vault" && pages[6].status == true ? (
                      <button
                        //  to={isConnected ? "/supportTicket" : "/"}
                        onClick={(e) =>
                          isConnected ? navigate("/vault") : toast.error("Please Connect Wallet")
                        }
                      >
                        Vault
                      </button>
                    ) : (
                      ""
                    )}


                    {pages[7].pageName == "Referral" && pages[7].status == true ? (
                      <button
                        //  to={isConnected ? "/supportTicket" : "/"}
                        onClick={(e) =>
                          isConnected ? navigate("/referral") : toast.error("Please Connect Wallet")
                        }
                      >
                        Referral
                      </button>
                    ) : (
                      ""
                    )}


                  </>
                ) : (
                  ""
                )} */}




                <div className="btn_sec">
                  {console.log(accountInfo, "accountInfo")}
                  {accountInfo == "" || accountInfo == null ? (
                    <Button
                      className="cmn_blueBtn getStarted_btn"
                      onClick={handleShowWallet}
                    >
                      Connect Wallet
                    </Button>
                  ) : (
                    <>
                      <Dropdown className={drop && "show"} onMouseOver={() => setDrop(true)} onMouseLeave={() => setDrop(false)}>
                        <Dropdown.Toggle
                          className={`cmn_blueBtn getStarted_btn ${drop && "show"}`}
                        >
                          <img
                            className="img-fluid header__networkImg me-2"
                            src={CHAINS[networkSwitch].IMAGE}
                          />
                          {`${accountInfo.substring(
                            0,
                            6
                          )}...${accountInfo.substring(36, 42)}`}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className={drop && "show"} show={drop}>
                          <Button
                            className="cmn_blueBtn getStarted_btn"
                            onClick={logOut}
                          >
                            Disconnect
                          </Button>
                        </Dropdown.Menu>
                      </Dropdown>
                      {/* <Button
                        className="cmn_blueBtn getStarted_btn"
                        onClick={logOut}
                      >
                        <img
                          className="img-fluid header__networkImg me-2"
                          src={CHAINS[networkSwitch].IMAGE}
                        />
                        {`${accountInfo.substring(
                          0,
                          6
                        )}...${accountInfo.substring(36, 42)}`}
                      </Button> */}
                    </>
                  )}

                  <Button className="hamburgerBtn" onClick={handleShow}>
                    <i class="fa-solid fa-bars" />
                  </Button>
                </div>

              </div>


            </div>
          </div>
        </Container>
      </div>

      {/* offcanvas */}
      <Offcanvas
        show={show}
        placement="end"
        className="newHeader_offcanva"
        onHide={handleClose}
        backdrop="static"
      >
        <Offcanvas.Body>
          <div className="header__canvaTop d-flex justify-content-between align-items-center">
            <img src={Images.logo} className="img-fluid logo" alt="" />
            <button className="closeBtn" onClick={handleClose}>
              <i class="fa-solid fa-xmark fa-beat-fade" />
            </button>
          </div>

          <div className="nav_cnts">
            <NavLink to={isConnected ? "/dashboard" : "javascript:;"} onClick={handleWallet}>Dashboard</NavLink>
            <NavLink to={isConnected ? "/transactionHistory" : "javascript:;"} onClick={handleWallet}>Transaction History</NavLink>
            <NavLink to={isConnected ? "/opportunities" : "javascript:;"} onClick={handleWallet}>Market Opportunities</NavLink>

            <NavLink to={isConnected ? "/plans" : "javascript:;"} onClick={handleWallet}>Plans</NavLink>
            <NavLink to={isConnected ? "/scheduleHistory" : "javascript:;"} onClick={handleWallet}>Schedule History</NavLink>
            <NavLink to={isConnected ? "/vault" : "javascript:;"} onClick={handleWallet}>Vault</NavLink>
            <NavLink to={isConnected ? "/referral" : "javascript:;"} onClick={handleWallet}>Referral</NavLink>

            {/* {pages && pages.length > 0 ? (
              <>
                {pages[0].pageName == "Dapp" && pages[0].status == true ? (
                  <button
                    // to={isConnected ? "/dashboard" : "/"}
                    onClick={(e) =>
                      isConnected ? navigate("/dashboard") : toast.error("Please Connect Wallet")
                    }
                  >
                    Dapp
                  </button>
                ) : (
                  ""
                )}

                {pages[1].pageName == "Transaction History" &&
                  pages[1].status == true ? (
                  <button
                    // to={isConnected ? "/transactionHistory" : "/"}
                    onClick={(e) =>
                      isConnected ? navigate("/transactionHistory") : toast.error("Please Connect Wallet")
                    }
                  >
                    Transaction History
                  </button>
                ) : (
                  ""
                )}

                {pages[2].pageName == "Market Opportunities" &&
                  pages[2].status == true ? (
                  <button
                    // to={isConnected ? "/opportunities" : "/"}
                    onClick={(e) =>
                      isConnected ? navigate("/opportunities") : toast.error("Please Connect Wallet")
                    }
                  >
                    Market Opportunities
                  </button>
                ) : (
                  ""
                )}
                {pages[3].pageName == "Plans" &&
                  pages[3].status == true ? (
                  <button
                    // to={isConnected ? "/plans" : "/"}
                    onClick={(e) =>
                      isConnected ? navigate("/plans") : toast.error("Please Connect Wallet")
                    }
                  >
                    Plans
                  </button>
                ) : (
                  ""
                )}

                {pages[5].pageName == "ScheduleHistory" &&
                  pages[5].status == true ? (
                  <button
                    // to={isConnected ? "/scheduleHistory" : "/"}
                    onClick={(e) =>
                      isConnected ? navigate("/scheduleHistory") : toast.error("Please Connect Wallet")
                    }
                  >
                    Schedule History
                  </button>
                ) : (
                  ""
                )}

                {pages[6].pageName == "Vault" && pages[6].status == true ? (
                  <button
                    //  to={isConnected ? "/supportTicket" : "/"}
                    onClick={(e) =>
                      isConnected ? navigate("/vault") : toast.error("Please Connect Wallet")
                    }
                  >
                    Vault
                  </button>
                ) : (
                  ""
                )}

                {pages[7].pageName == "Referral" && pages[7].status == true ? (
                  <button
                    //  to={isConnected ? "/supportTicket" : "/"}
                    onClick={(e) =>
                      isConnected ? navigate("/referral") : toast.error("Please Connect Wallet")
                    }
                  >
                    Referral
                  </button>
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )} */}

          </div>
        </Offcanvas.Body>
      </Offcanvas>
      {/* end of offcanvas */}

      {/* modals */}

      <ConnectWallet show={showWallet} handleClose={handleCloseWallet} />
      {/* end of modals */}
    </>
  );
};

export default Header;
